export enum ChatTemplateHeaderType {
  TEXT = 'TEXT',
  MEDIA_VIDEO = 'MEDIA_VIDEO',
  MEDIA_IMAGE = 'MEDIA_IMAGE',
  MEDIA_DOCUMENT = 'MEDIA_DOCUMENT'
}
